// extracted by mini-css-extract-plugin
export var actions = "_gw-g";
export var benefitCard = "_gw-b";
export var benefitIcon = "_gw-d";
export var benefitLabel = "_gw-f";
export var benefits = "_gw-a";
export var benefitsSection = "_gw-8";
export var bodyText = "_gw-7";
export var closeButton = "_gw-2";
export var content = "_gw-3";
export var eyebrow = "_gw-4";
export var heading = "_gw-5";
export var image = "_gw-i";
export var imagePanel = "_gw-h";
export var modal = "_gw-0";
export var offerCard = "_gw-c";
export var offerIcon = "_gw-e";
export var sectionLabel = "_gw-9";
export var shell = "_gw-1";
export var title = "_gw-6";